//
import { ModuleLayout } from '@/components/reusable_components/next'

//
import UserListView from '@/views/General/GUser/GUserList'
import UserCreateView from '@/views/General/GUser/create'
import UserUpdateView from '@/views/General/GUser/update'
import GUserUpdatePasswordView from '@/views/General/GUser/GUserUpdatePassword'

//
export default {
    path: 'users',
    component: ModuleLayout,
    children: [
        {
            name: 'user-list',
            path: '',
            component: UserListView,
        },
        {
            name: 'user-create',
            path: 'create',
            component: UserCreateView,
            meta: {
                title: 'Crear usuario'
            },
        },
        {
            name: 'user-update',
            path: ':id',
            component: UserUpdateView,
            meta: {
                title: 'Datos de usuario'
            },
        },
        {
            name: 'user-update-password',
            path: ':id/password',
            component: GUserUpdatePasswordView,
            meta: {
                title: 'Contraseña de usuario'
            },
        },
    ],
    meta: {
        title: 'Usuarios'
    },
}